import { faArrowLeft, faArrowRight, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  FORMAT_DATE_PICKER,
  TYPE_ENTRIES,
  TYPE_HAND_OUT,
  TYPE_MOVEMENTS,
  TYPE_MOVEMENTS_DETAIL,
  TYPE_MOVEMENT_ENTRY
} from "../../../../../api/constant";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./movements.css";
import {
  useArticle,
  useDispatchArticleForm,
  useActionsArticle
} from "../../../../../context/inventory/ArticleFormProvider";
import { customStyles } from "../../../../../utilities/select-styles.utilities";
import { types } from "../../../../../reducers/inventory/articleReducer";
import { pluckArrayObject } from "../../../../../utilities/math.utilities";
import Pagination from "../../../../app/atoms/Pagination";
import { formatNumberCOP } from "../../../../../utilities/app.utilities";
const Movements = () => {
  const state = useArticle();
  const dispatch = useDispatchArticleForm();
  const {downloadMovements }=useActionsArticle();
  const { movements, users, warehouses } = state.article;
  const {
    init_date,
    end_date,
    warehouses_id,
    responsables_id,
    limit,
    page,
    type_code,
    types_detail
  } = movements.filter;
  return (
    <section>
      <div className=" container-filter-movementes">
        <div className="form-group ">
          <label>Movimiento</label>
          
          <Select
            placeholder="Movimiento"
            value={TYPE_MOVEMENTS.filter(t=>t.code===type_code)}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: {
                  name: "type_code",
                  value: e?e.code:null
                },
              })
            }
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
            isClearable
            options={TYPE_MOVEMENTS}
            styles={customStyles}
          />
        </div>
        {type_code&&(
        <div className="form-group ">
          <label>Tipo</label>

          <Select
            placeholder="Tipo"
            value={(type_code===TYPE_MOVEMENT_ENTRY?TYPE_ENTRIES:TYPE_HAND_OUT).filter((w) =>  types_detail.includes(w.code))}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: {
                  name: "types_detail",
                  value: pluckArrayObject(e, "code"),
                },
              })
            }
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
            options={type_code===TYPE_MOVEMENT_ENTRY?TYPE_ENTRIES:TYPE_HAND_OUT}
            isMulti
            styles={customStyles}
          />
        </div>
        )}
        <div className="form-group date-input">
          <label>Fecha inicial</label>
          <DatePicker
            selected={init_date}
            className="form-control "
            isClearable={true}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            scrollableYearDropdown
            onChange={(date) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: { name: "init_date", value: date },
              })
            }
            dateFormat={FORMAT_DATE_PICKER}
          />
        </div>
        <div className="form-group date-input">
          <label>Fecha final</label>
          <DatePicker
            selected={end_date}
            minDate={init_date}
            isClearable={true}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            scrollableYearDropdown
            onChange={(date) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: { name: "end_date", value: date },
              })
            }
            className="form-control"
            dateFormat={FORMAT_DATE_PICKER}
          />
        </div>
        <div  style={{minWidth:"14rem"}}  className="form-group ">
          <label>Sede</label>
          <Select
            placeholder="Sede"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            options={[]}
            styles={customStyles}
          />
        </div>
        <div style={{minWidth:"14rem"}} className="form-group ">
          <label>Almacén</label>

          <Select
            placeholder="Almacén"
            value={warehouses.elements.filter((w) =>
              warehouses_id.includes(w.id)
            )}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: {
                  name: "warehouses_id",
                  value: pluckArrayObject(e, "id"),
                },
              })
            }
            getOptionLabel={(option) => option.code + " - " + option.name}
            getOptionValue={(option) => option.id}
            options={warehouses.elements}
            isMulti={true}
            styles={customStyles}
          />
        </div>
        <div style={{minWidth:"14rem"}} className="form-group ">
          <label>Responsable</label>
          <Select
            placeholder="Responsable"
            value={users.elements.filter((w) => responsables_id.includes(w.id))}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            options={users.elements}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
                payload: {
                  name: "responsables_id",
                  value: pluckArrayObject(e, "id"),
                },
              })
            }
            isMulti={true}
            styles={customStyles}
          />
        </div>
        <div className="form-group ">
          <label ></label>
          <div
          onClick={()=>downloadMovements()}
            
            className="flex btn-default"
          >
            <FontAwesomeIcon
              className="margin-auto"
              icon={faFileExcel}
            />
            &nbsp;
            <span> Exportar </span>
          </div>
        </div>
        
      </div>
      <table className="table table-default-app">
        <thead className="thead-dark">
          <tr className="txt-center">
            <th>ID</th>
            <th>Movimiento</th>
            <th>Tipo</th>
            <th>Und. medida</th>
            <th>Cant.</th>
            <th>Lote</th>
            <th>Fecha venc</th>
            <th>Proovedor</th>
            <th>ID compra</th>
            <th>Fecha Ingreso</th>
            <th>Responsable</th>
            <th>Almacén</th>
          </tr>
        </thead>
        <tbody>
          {movements.elements.map((m) => {
            if (m.date_expired === "2300-12-31") {
              m.lote = "N.A"
              m.date_expired = "N.A";
            }
            if (m.date_expired==null) {
              m.date_expired = "N.A";
            }
            return (
              <tr key={m.id}>
                <td>{m.id}</td>
                <td>
                  {" "}
                  <FontAwesomeIcon
                    style={{
                      color:
                        m.type_movement_code === TYPE_MOVEMENT_ENTRY
                          ? "green"
                          : "red",
                    }}
                    icon={
                      m.type_movement_code === TYPE_MOVEMENT_ENTRY
                        ? faArrowRight
                        : faArrowLeft
                    }
                  />
                  &nbsp;{" "}
                  {m.type_movement_code === TYPE_MOVEMENT_ENTRY
                    ? "Entrada"
                    : "Salida"}
                </td>
                <td>{TYPE_MOVEMENTS_DETAIL[m.type]}</td>
                <td>{m.abreviature}</td>
                <td className="txt-right"> {formatNumberCOP(m.quantity)} </td>
                <td> {m.lote} </td>
                <td>{m.date_expired}</td>
                <td> {m.provider_name} </td>
                <td> {m.order_number} </td>
                <td>{m.date_movement} </td>
                <td> {m.user_name} </td>
                <td> {m.warehouse_name} </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-end">
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
              payload: { name: "page", value: e },
            })
          }
          page={page}
          limit={limit}
          rows={movements.rows}
        />
      </div>
    </section>
  );
};

export default Movements;
